// Review R120 #14 (round 6): when the server can't read the Issues board
// (its overlay), it refuses a field login's action on a finding or a
// quick-logged ticket with 503 code 'board_unknown' and saves NOTHING. It
// fails closed because the board may hold a dismissal it can't see. The field
// pages (Housekeeping, Inspections, Quick Log, Issues, and the Log issues
// modal) say so in the same plain words and offer the same request again:
// one bar at the top of the screen with one "Try again".
export const BOARD_UNKNOWN_MSG = 'Could not check the Issues board just now. Nothing was saved. Try again.';

/** The server's fail-closed answer: the Issues board could not be read. */
export function isBoardUnknown(status: number | null | undefined, body: any): boolean {
  return status === 503 && !!body && typeof body === 'object' && body.code === 'board_unknown';
}

/**
 * Show the bar (one at a time). "Try again" closes it and runs `retry` (the
 * same request again); "Not now" just closes it. → the bar element.
 */
export function offerBoardRetry(retry: () => unknown): HTMLElement {
  document.querySelectorAll('[data-board-retry]').forEach(n => n.remove());
  const bar = document.createElement('div');
  bar.setAttribute('data-board-retry', '');
  bar.setAttribute('role', 'alert');
  bar.style.cssText = [
    'position:fixed', 'left:16px', 'right:16px', 'top:calc(env(safe-area-inset-top, 0px) + 16px)', 'z-index:9650',
    'margin:0 auto', 'max-width:520px', 'box-sizing:border-box', 'display:flex', 'align-items:center', 'flex-wrap:wrap', 'gap:8px 10px',
    'padding:12px 14px', 'border-radius:12px', 'background:var(--warning-soft, #fffbeb)', 'color:var(--warning-text, #92400e)',
    'border:1px solid var(--warning, #b45309)', 'box-shadow:0 8px 30px rgba(0,0,0,.18)', 'font-size:14px', 'line-height:1.4',
  ].join(';');
  const msg = document.createElement('span');
  msg.setAttribute('data-board-retry-msg', '');
  msg.style.cssText = 'flex:1 1 200px; min-width:0; overflow-wrap:anywhere;';
  msg.textContent = BOARD_UNKNOWN_MSG;
  const btns = document.createElement('span');
  btns.style.cssText = 'display:flex; gap:8px; flex:0 0 auto; margin-left:auto;';
  const go = document.createElement('button');
  go.type = 'button';
  go.setAttribute('data-board-retry-go', '');
  go.textContent = 'Try again';
  go.style.cssText = 'min-height:40px; padding:8px 16px; border-radius:10px; border:1px solid transparent; background:var(--accent, #2563eb); color:#fff; font:inherit; font-weight:600; cursor:pointer;';
  const no = document.createElement('button');
  no.type = 'button';
  no.setAttribute('data-board-retry-close', '');
  no.textContent = 'Not now';
  no.style.cssText = 'min-height:40px; padding:8px 14px; border-radius:10px; border:1px solid var(--border, #e2e8f0); background:var(--card, #fff); color:var(--text, #0f172a); font:inherit; cursor:pointer;';
  btns.append(go, no);
  bar.append(msg, btns);
  document.body.appendChild(bar);
  go.addEventListener('click', () => {
    bar.remove();
    try { void Promise.resolve(retry()).catch(() => { /* the retry says its own outcome */ }); } catch { /* idem */ }
  });
  no.addEventListener('click', () => bar.remove());
  return bar;
}
